/**
*  会员查询 - 组件
*/
<template>
  <div class="h-vip">
    <query-valid type="vip"></query-valid>
  </div>
</template>
<script>
import { footerList } from '@/mock' // 脚部数据
import { footerData } from '@/api'
import QueryValid from '@/views/QueryValid' // 查询组件

export default {
  name: 'FooterBar',
  components: { QueryValid },
  props: {},
  data () {
    return {
      footerData: [],
    }
  },
  created () {
    // this.getFooterData() // 底部数据加载
  },
  mounted () {
    this.footerData = footerList.result // 使用接口时 此处删除
  },
  methods: {
    getFooterData () {
      const params = { // 请求参数 --- 根据情况 是否需要
        id: '111'
      }
      footerData(params).then(res => {
        this.footerData = res
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .h-vip {
  }
</style>
